import { FormikHelpers } from "formik";

export type ForwardTradeChangeRequestModalDefaultProps = {
  visible: boolean;
  closeModal: () => void;
};

export enum ForwardTradeChangeRequestModalMode {
  Add = "add",
  Edit = "edit",
  Counter = "counter",
}

export type ForwardTradeChangeRequestModalCustomProps = {
  initialData: {
    tradeContractId: string;
    paymentDate: string;
    deliveryDate: string;
  };
  mode: ForwardTradeChangeRequestModalMode;
};

export type ForwardTradeChangeRequestModalFormValues = {
  paymentDate: string;
  deliveryDate: string;
};

export type ForwardTradeChangeRequestModalProps = ForwardTradeChangeRequestModalDefaultProps &
  ForwardTradeChangeRequestModalCustomProps;

export type UseForwardTradeChangeRequestModal = (args: ForwardTradeChangeRequestModalProps) => {
  onSubmit: (
    values: ForwardTradeChangeRequestModalFormValues,
    formikHelpers: FormikHelpers<ForwardTradeChangeRequestModalFormValues>,
  ) => Promise<void>;
};

export type ForwardTradeChangeRequestModalViewProps = ForwardTradeChangeRequestModalProps &
  ReturnType<UseForwardTradeChangeRequestModal>;

export const ForwardTradeChangeRequestModalTitle = {
  [ForwardTradeChangeRequestModalMode.Add]: "Place a Change Request",
  [ForwardTradeChangeRequestModalMode.Edit]: "Edit Change Request",
  [ForwardTradeChangeRequestModalMode.Counter]: "Counter Change Request",
};
